import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { ModalV2Component } from '../modal-v2/modal-v2.component';
import { ModalFooterDirective } from '../modal-v2/directives/modal-footer.directive';
import { ButtonComponent } from '../button/button.component';
import { IconComponent } from '../icon/icon.component';
import { AnimatedIconComponent } from '../animated-icon/animated-icon.component';
import { InputComponent } from '../input/input.component';
import { StatusModalService } from '../../services/status-modal/status-modal.service';

@Component({
  selector: 'app-status-modal',
  imports: [ModalV2Component, ModalFooterDirective, ButtonComponent, IconComponent, AnimatedIconComponent, InputComponent],
  templateUrl: './status-modal.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusModalComponent {
  protected readonly statusModalService = inject(StatusModalService);
  protected readonly options = this.statusModalService.options;
  protected readonly step = this.statusModalService.step;
  protected readonly loadingContent = this.statusModalService.loadingContent;
  protected readonly loadingIcon = this.statusModalService.loadingIcon;
  protected readonly successContent = this.statusModalService.successContent;
  protected readonly failedContent = this.statusModalService.failedContent;
  protected readonly canRetry = this.statusModalService.canRetry;
  protected readonly inputValue = this.statusModalService.inputValue;
  protected readonly inputError = this.statusModalService.inputError;
  protected readonly modalTitle = computed(() => {
    const options = this.options();
    if (!options) return '';

    switch (this.step()) {
      case 'loading':
        return this.loadingContent().title;
      case 'success':
        return this.successContent().title;
      case 'failed':
        return this.failedContent().title;
      default:
        return options.title;
    }
  });

  protected close(): void {
    this.statusModalService.close();
  }

  protected submit(): void {
    void this.statusModalService.submit();
  }

  protected deny(): void {
    this.statusModalService.deny();
  }

  protected stop(): void {
    this.statusModalService.stop();
  }

  protected onInput(value: string): void {
    this.statusModalService.setInputValue(value);
  }
}
